"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddFile = void 0;

var React = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

/* eslint-disable no-eq-null */
const Container = _styledComponents.default.div`
  flex: 1;
`;
const AddFileButton = (0, _styledComponents.default)(_blocks.Button)`
  flex: none;

  label {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 5;
  }

  span {
    position: static;
  }

  input {
    visibility: hidden;
  }
`;
const AttachContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  gap: ${_blocks.spacing.tight};
`;
const FileName = (0, _styledComponents.default)(_blocks.BodySmall)``;
const ErrorMessage = (0, _styledComponents.default)(_blocks.BodySmall)`
  flex: 1;
  color: ${_blocks.color.theme.input.error.foreground};
  white-space: pre-wrap;
`;
const FileNameText = _styledComponents.default.span`
  flex: 1;
  width: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ALLOWED_FILE_TYPES = [// Image Files
['.jpg', 'image/jpeg'], ['.jpeg', 'image/jpeg'], ['.png', 'image/png'], ['.gif', 'image/gif'], ['.bmp', 'image/bmp'], ['.svg', 'image/svg+xml'], ['.ico', 'image/x-icon'], ['.tif', 'image/tiff'], ['.tiff', 'image/tiff'], ['.webp', 'image/webp'], // Document Files
['.doc', 'application/msword'], ['.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'], ['.pdf', 'application/pdf'], ['.txt', 'text/plain'], ['.rtf', 'application/rtf'], ['.odt', 'application/vnd.oasis.opendocument.text'], // Spreadsheet Files
['.xls', 'application/vnd.ms-excel'], ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'], ['.csv', 'text/csv'], // Presentation Files
['.ppt', 'application/vnd.ms-powerpoint'], ['.pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'], ['.odp', 'application/vnd.oasis.opendocument.presentation'], // Audio Files
['.mp3', 'audio/mpeg'], ['.wav', 'audio/wav'], ['.ogg', 'audio/ogg'], // Video Files
['.mp4', 'video/mp4'], ['.mov', 'video/quicktime'], ['.avi', 'video/x-msvideo'], ['.wmv', 'video/x-ms-wmv'], ['.mkv', 'video/x-matroska'], // Archive Files
['.zip', 'application/zip']];
const allowedMimeType = ALLOWED_FILE_TYPES.reduce((acc, [, mimeType]) => {
  acc.add(mimeType);
  return acc;
}, new Set());
const allowedExtensions = ALLOWED_FILE_TYPES.reduce((acc, [ext]) => {
  acc.add(ext);
  return acc;
}, new Set());

const AddFile = ({
  onChange,
  onCancel,
  fileName,
  id,
  label = 'Attach file'
}) => {
  const [isInvalidFile, setInvalidFile] = React.useState(false);

  const handleChange = event => {
    var _event$currentTarget$;

    setInvalidFile(false);
    const file = (_event$currentTarget$ = event.currentTarget.files) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$[0];
    if (file == null) return onChange(event);

    if (!allowedMimeType.has(file.type)) {
      event.preventDefault();
      return setInvalidFile(true);
    }

    onChange(event);
  };

  const handleCancel = () => {
    setInvalidFile(false);
    onCancel();
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(AttachContainer, null, /*#__PURE__*/React.createElement(AddFileButton, {
    wafer: true,
    appearance: "outline"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: [...allowedExtensions.values()].join(','),
    onChange: handleChange,
    id: id
  })), label), fileName !== undefined && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileName, null, /*#__PURE__*/React.createElement(FileNameText, null, fileName !== null && fileName !== void 0 ? fileName : 'Sample.pdf')), /*#__PURE__*/React.createElement(_blocks.Button, {
    wafer: true,
    appearance: "plain",
    onClick: handleCancel
  }, /*#__PURE__*/React.createElement(_blocks.Remove, {
    tiny: true
  })))), isInvalidFile && /*#__PURE__*/React.createElement(ErrorMessage, null, _core.i18n._({
    id: 'inline_edit_action.invalid_filetype',
    message: 'For security purposes this filetype is not allowed. Please selected a different file.'
  })));
};

exports.AddFile = AddFile;